import React ,{useContext,useEffect,useState} from 'react'
import { GoogleMap, useJsApiLoader  , Marker} from '@react-google-maps/api';
import './map.component.style.scss';
import { DeviceContext } from './../../../components/device-provider/device-provider';
import { isValid } from './../../../utils/utilities';
import { Button } from "antd";


let zoom = 13 ;

const isValidLatLng = (p) =>
  isValid(p) && isValid(p.lat) && isValid(p.lng) && !Number.isNaN(Number(p.lat)) && !Number.isNaN(Number(p.lng));

const isSamePoint = (a, b, epsilon = 1e-6) => {
  if (!isValidLatLng(a) || !isValidLatLng(b)) return false;
  return Math.abs(Number(a.lat) - Number(b.lat)) <= epsilon && Math.abs(Number(a.lng) - Number(b.lng)) <= epsilon;
};

function MyComponent(props) {

  const {
    isMobile
  }=useContext(DeviceContext);

  let containerStyle = {
    width: '65vw',
    height: '65vh'
  };

  if(isMobile){
    containerStyle['width']='92vw';
    containerStyle['height']='100vh';
  }

    const {
        enableLocationPick,
        boardingLatLng,
        dropLatLng,
        sameDetailsForDrop,
        activeMarkerType, // "pickup" | "drop" | null
        onMarkerDragEnd,  // (lat,lng,markerType?) => void
        onCancel,         // (markerType,lat,lng) => void
        setEnableLocationPick,
        center
    } = props;

    const [cachedBoarding, setCachedBoarding] = useState(null);
    const [cachedDrop, setCachedDrop] = useState(null);

    useEffect(() => {
      if (isValidLatLng(boardingLatLng)) setCachedBoarding({ ...boardingLatLng });
    }, [boardingLatLng?.lat, boardingLatLng?.lng]);

    useEffect(() => {
      if (isValidLatLng(dropLatLng)) setCachedDrop({ ...dropLatLng });
    }, [dropLatLng?.lat, dropLatLng?.lng]);


  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: `${global.googleMapsApi}`
  });

  const getPinIcon = (fillColor, text) => {
    // Google-like marker pin with highlight + subtle shadow.
    // ViewBox is 48x64, anchor at bottom tip (24,64)
    const safeText = String(text || '').slice(0, 3);
    const svg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="64" viewBox="0 0 48 64"
      
      >
        <defs>
          <filter id="ds" x="-35%" y="-25%" width="170%" height="170%">
            <feDropShadow dx="0" dy="2" stdDeviation="2.2" flood-color="#000" flood-opacity="0.25"/>
          </filter>
          <radialGradient id="shine" cx="30%" cy="22%" r="60%">
            <stop offset="0%" stop-color="#ffffff" stop-opacity="0.55"/>
            <stop offset="55%" stop-color="#ffffff" stop-opacity="0.12"/>
            <stop offset="100%" stop-color="#ffffff" stop-opacity="0"/>
          </radialGradient>
          <linearGradient id="rim" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#ffffff" stop-opacity="0.55"/>
            <stop offset="100%" stop-color="#000000" stop-opacity="0.10"/>
          </linearGradient>
        </defs>
        <g filter="url(#ds)">
          <!-- Outer pin base -->
          <path d="M24 63C24 63 8 45.9 8 29C8 15.2 17.7 5 24 5C30.3 5 40 15.2 40 29C40 45.9 24 63 24 63Z"
                fill="${fillColor}" stroke="#ffffff" stroke-width="2"/>
          <!-- subtle rim shading -->
          <path d="M24 63C24 63 8 45.9 8 29C8 15.2 17.7 5 24 5C30.3 5 40 15.2 40 29C40 45.9 24 63 24 63Z"
                fill="url(#rim)" opacity="0.55"/>
          <!-- highlight -->
          <ellipse cx="20" cy="18" rx="18" ry="20" fill="url(#shine)"/>

          <!-- Big top circle (hole) with slight inner depth -->
          <circle cx="24" cy="27" r="12.0" fill="#ffffff"/>
          <circle cx="24" cy="27" r="10.6" fill="#ffffff" opacity="0.92"/>
          <circle cx="24" cy="27" r="10.6" fill="#000000" opacity="0.05"/>

          <!-- Label inside circle -->
          <text x="24" y="31" text-anchor="middle"
                font-family="Arial, sans-serif"
                font-size="14"
                font-weight="700"
                fill="#111827">${safeText}</text>
        </g>
      </svg>
    `.trim();
    const url = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;

    const g = typeof window !== 'undefined' ? window.google : null;
    if (g?.maps?.Size && g?.maps?.Point) {
      return {
        url,
        scaledSize: new g.maps.Size(48, 64),
        anchor: new g.maps.Point(24, 64)
      };
    }

    return { url };
  };

  const onDragEnd =(coord, markerType)=>{
    let{
      latLng
    } = coord;
    let lat = latLng.lat();
    let lng = latLng.lng();
    onMarkerDragEnd(lat,lng,markerType);
  }

  return isLoaded ? (
        <div className='hightlight-div'>
            {enableLocationPick&&
               <div className='map-top-header'>
                  Click any where on map to set the location
                </div>
            }
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={{
                lat: center.lat || 13.0694,
                lng: center.lng || 80.1948
              }}              
              defaultZoom={zoom}
              zoom={zoom}
              onClick={(e)=>{
                if(enableLocationPick){
                  let lat = e.latLng.lat();
                  let lng = e.latLng.lng();
                  const fallbackType = isValidLatLng(boardingLatLng) ? 'drop' : 'pickup';
                  onMarkerDragEnd(lat,lng,activeMarkerType || fallbackType);
                }
              }}
            >
              {(() => {
                const hasBoarding = isValidLatLng(boardingLatLng);
                const hasDrop = isValidLatLng(dropLatLng);
                const same = sameDetailsForDrop || (hasBoarding && hasDrop && isSamePoint(boardingLatLng, dropLatLng));

                const markers = [];

                if (hasBoarding) {
                  markers.push({
                    key: 'pickup',
                    label: same ? 'B/D' : 'B',
                    position: { lat: Number(boardingLatLng.lat), lng: Number(boardingLatLng.lng) }
                  });
                }

                if (hasDrop && !same) {
                  markers.push({
                    key: 'drop',
                    label: 'D',
                    position: { lat: Number(dropLatLng.lat), lng: Number(dropLatLng.lng) }
                  });
                }

                return markers.map((m) => (
                  <Marker
                    shape="MarkerShapeRect"
                    icon={getPinIcon(m.key === 'drop' ? '#E24A4A' : '#4A90E2', m.label)}
                    key={m.key}
                    position={m.position}
                    label={undefined}
                    draggable={true}
                    onDragEnd={(e) => onDragEnd(e, m.key)}
                    onDrag={(e) => onDragEnd(e, m.key)}
                  />
                ));
              })()}

            </GoogleMap>
            {enableLocationPick&&
            <div className='map-footer-header'>
              <Button  
              className='cancel-button'
              onClick={()=>{
                setEnableLocationPick(false);
                if (activeMarkerType === 'pickup' && isValidLatLng(cachedBoarding)) {
                  onCancel('pickup', cachedBoarding.lat, cachedBoarding.lng);
                } else if (activeMarkerType === 'drop' && isValidLatLng(cachedDrop)) {
                  onCancel('drop', cachedDrop.lat, cachedDrop.lng);
                } else if (activeMarkerType === 'pickup' && isValidLatLng(boardingLatLng)) {
                  onCancel('pickup', boardingLatLng.lat, boardingLatLng.lng);
                } else if (activeMarkerType === 'drop' && isValidLatLng(dropLatLng)) {
                  onCancel('drop', dropLatLng.lat, dropLatLng.lng);
                }
              }}
              >
                  Cancel
              </Button>
              <Button className='set-location'
              onClick={()=>{
                setEnableLocationPick(false);
              }}
              >
                  Set Location
              </Button>
            </div>
            }
        </div>
  ) : <></>
}

export default React.memo(MyComponent);

//Note refs: https://stackoverflow.com/questions/64165413/react-google-maps-api-directionsservice-keeps-rerendering-itself
// https://codesandbox.io/s/eloquent-hopper-16k2e?file=/src/App.js:288-431
// https://stackoverflow.com/questions/64165413/react-google-maps-api-directionsservice-keeps-rerendering-itself